import moment from "moment";

import { TIME_LOOKBACK_RANGES_TO_DAYS_AGO, TimeLookbackRange } from "@types";

export const calculateLookbackSeconds = (tlr: TimeLookbackRange) => {
  const daysAgo = TIME_LOOKBACK_RANGES_TO_DAYS_AGO[tlr];
  return daysAgo === Infinity ? 0 : moment().subtract(daysAgo, "days").unix();
};
